import { AxiosStatic } from "@didi/dajax"
import { getExternalChannel } from "@/utils/common"
import { trackApiEvent } from '@didi/error-base'
import { IRequestConfig, IRequestResponse } from '@/api/common/request'
import { TranslateResult } from 'vue-i18n'
import { createAxiosInterceptor } from "@didi/wsgsdk-corejs3"

// eslint-disable-next-line @typescript-eslint/no-var-requires
const axios: AxiosStatic = require('@didi/dajax').default

export const ax = axios.create({
  baseURL: `${window.location.origin}`,
  needEncrypt: false,
})

// 加签
ax.interceptors.request.use(config => {
  if(!config.headers?.['Content-Type'] && typeof config.data === 'object'){
    config.headers['Content-Type'] = 'application/json;charset=utf-8'
  }
	createAxiosInterceptor({placement: 'query'})(config)
	return config
})

ax.interceptors.request.use((config: IRequestConfig) => {
  const { url, baseURL , params, data }  = config

  /**
   * 挂载接口错误上报方法
  */
  config.trackApiDone = trackApiEvent(
      // 链接配置
      {
        url, 
        baseURL
      },
      // 接口参数
      data || params,
      {
        // errCode: string[] 错误码key（返回体中data的错误码属性）,响应体中 错误码的 key 名称，可以是一个，也可以是多个
        errCode: ["errorCode"],
        // errMsg: string[] 错误信息key（返回体中data的错误信息属性）
        errMsg: ["errorMsg"],
        // 接口成功码
        successCode: [0, 10000, 29999],
        // (非必需) headerTraceIdKeys: string[] 如果需要从 header 中获取 trace id。可以提供对应的 header 名称
        headerTraceIdKeys: ["trace-id", "colored-didi-header-rid"],
        // (非必需) dataTraceIdKeys: string[] 如果需要从 response.data 中获取 trace id。可以提供对应的 字段的名称.
        dataTraceIdKeys: ["traceId"],
        // headerTraceIdKeys 和 dataTraceIdKeys 都不是必须的，按照自己的实际情况填写即可
      }
    )

  return config
})

ax.interceptors.response.use(
  (response: IRequestResponse) => {
    const { data, config } = response

    if (config.trackApiDone) {
      config.trackApiDone(true, response)
    }

    // 请求成功
    if (data?.errorCode === 10000 ||
      data?.errorCode === 0 ||
      data?.errorCode === 29999
    ) {
      return Promise.resolve(data)
    }
    return Promise.reject(data)
  },
  (error) => {
    const { config, code } = error
    const message: string | TranslateResult =
      error.message || ''

    if(config.trackApiDone) {
       config.trackApiDone(false, undefined, { code, message, error });
    }
    // 所有错误都往上抛
    throw { ...error }
  }
)

const $httpWithGateway = (
  url: string,
  data = {},
  config?: IRequestConfig
) => {
  const externalChannel = getExternalChannel()
  return ax.post(url, {
    externalChannel,
    ...data,
  }, {
    baseURL: process.env['VUE_APP_API_GATEWAY'],
    ...config,
  })
}

interface IData {
  [key: string]: string | number | any
}

/**
 * 外投素材页接口
 * @param data 
 * @param config 
 * @returns 
 */
export const queryApolloConfig = (
  data?: IData,
  config?: IRequestConfig
) => {
  return $httpWithGateway(
    `/apollo/market`,
    data,
    config
  )
}